
export class ThinkVsInsightSetting {

      public static insight = {
            userPage: {
                  visible: false
            }
      }

      public static think = {
            userPage: {
                  visible: true
            }
      }

}



// WEBPACK FOOTER //
// ./src/app/pages/shared/think-vs-insight-setting.service.ts